module.exports = __webpack_public_path__ + "static/on-immunity-f912b519b4701c6e4110afbc86878654.jpg";